import { put, takeLatest } from "redux-saga/effects";

import axios from "axios";


import { constantApi } from "../../../utility/api/apiList";
import constantType from "./constantType";
import { successFetchedConstant, failureFetchedConstant } from "./constantAction";

export function* startfetchingProduct (action) {
    
    try{
        const response =yield axios.get(constantApi)
         const handlesuccess = yield put(successFetchedConstant(response.data))

    }catch(error){
        const handlefailed=  yield put(failureFetchedConstant(''))

    }
    
    // try{
    //     const response =yield onHistoryChange(action.search)
    //      const handlesuccess = yield put(successFetchedConstant(response.data))

    // }catch(error){
    //     const handlefailed=  yield put(failureFetchedConstant(''))

    // }
}


export function* fetchConstat (){
yield takeLatest(constantType.START_FETCHING_CONSTANT,startfetchingProduct )

}




